function smoothScroll(linkDOM) {
  linkDOM = linkDOM || location;

  if (
    linkDOM.hash &&
    (location.pathname == linkDOM.pathname ||
      location.hostname == linkDOM.hostname)
  ) {
    const target = $(linkDOM.hash);

    if (target.length) {
      $("html,body").animate(
        {
          scrollTop: target.offset().top //Scroll to position
        },
        1000
      );

      return false;
    }
  }
}

function clickOutside($container, e) {
  const toggleClass = $container.data("toggle-class");

  if (!$container.is(e.target) && $container.has(e.target).length === 0) {
    $("." + toggleClass).removeClass(toggleClass);
    $(".wrapper").removeClass(toggleClass);
  }
}

function sticktothetop() {
  if ($(".header .stick-here").length) {
    const windowTop = $(window).scrollTop();
    const top = $(".header .stick-here").offset().top;

    windowTop > top
      ? $(".header__body").addClass("stick")
      : $(".header__body").removeClass("stick");
  }
}

module.exports = {
  smoothScroll,
  clickOutside,
  sticktothetop
};
